
  import { mapGetters,mapActions } from 'vuex'
  export default {
  props: {
    id: {
      default: '',
      type: String,
    },
    header: {
      default: '',
      type: String,
    },
    url: {
      default: '#',
      type: String,
    },
    bg: {
      default: 'blue',
      type: String,
    },
    btn: {
      default: '',
      type: String,
    },
    modal: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      isActive: this.active !== ''
    }
  },

  computed: {
    ...mapGetters({
      activeModal : 'pages/getActiveModal',
    }),
  },
  methods:{
      ...mapActions({
        updateActiveModal: 'pages/updateActiveModal', // map `this.add()` to `this.$store.commit('increment')`
      }),
      updateModal(id){
        const newId = this.$nuxt.$options.filters.convertModal(id)
        this.updateActiveModal(newId)
        console.log('Active Modal: ',this.activeModal)
      }
  },
  render() {
    const slot = this.$slots.default
    //  return slot.text.replace(/,/g, "")
    return slot
  },
}
